@if (!!reportForm) {
  <form class="overflow-hidden" [formGroup]="reportForm" (ngSubmit)="downloadReport(reportForm)">
    <h1 mat-dialog-title class="report-form-header">Transactions Reports:</h1>
    <mat-dialog-content class="w-100 m-0 p-0 dialogContent overflow-hidden">
      <mat-form-field>
        <mat-label>Report Types</mat-label>
        <mat-select formControlName="reportTypes" (selectionChange)="setSelectedType($event.value)">
          @for (type of reportTypes; track type.key) {
            <mat-option [value]="type.key">
              {{ type.displayText }}
            </mat-option>
          }
        </mat-select>
        @if (reportForm.get('reportTypes').hasError('required')) {
          <mat-error>Report type is required</mat-error>
        }     
      </mat-form-field>
      <div class="test-options-container">
        <label>Payment cadence</label>
        <mat-radio-group class="row options" formControlName="reportPeriod" (change)="getSelectedValue($event)">
          @for (selection of selections; track selection.key) {
            <mat-radio-button class="col-lg-3" [value]="selection.key"
              [disabled]="getDisabledRadioButton(selection.key)" [matTooltip]="getTooltipText(selection.key)"
              matTooltipClass="quartz-tooltip">
              {{ selection.value }}
            </mat-radio-button>
          }
        </mat-radio-group>
      </div>
      @if (reportForm.get('reportPeriod').value === ReportPeriod.Custom) {
        <mat-form-field class="col-md-6 col-12 pl-0 mr-0">
          <mat-label>Select Start Date</mat-label>
          <input matInput formControlName="startDate" [matDatepicker]="startDate"
            [max]="reportForm.get('endDate').value" />
          <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
          <mat-datepicker #startDate></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="col-md-6 col-12 pl-0 mr-0">
          <mat-label>Select End Date</mat-label>
          <input matInput formControlName="endDate" [matDatepicker]="endDate" [min]="reportForm.get('startDate').value"
            [max]="maxDate" />
          <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
          <mat-datepicker #endDate></mat-datepicker>
        </mat-form-field>
        @if (reportForm.get('endDate').errors?.invalidDateRange || reportForm.get('startDate').errors?.invalidDateRange) {
          <small class="text-danger">Date range must be less then or equal to 6 months</small>
        }
        
      }
      @if (reportForm.get('reportPeriod').value === ReportPeriod.LastMonth || reportForm.get('reportPeriod').value === ReportPeriod.LastQuarter) {
        <div class="d-md-flex d-block mt-3 mb-2">
          <label class="col-md-6 col-12 pl-0 mr-0">Start Date: {{ startDate | date : 'mediumDate'}}</label>
          <label class="col-md-6 col-12 pl-0 mr-0">End Date: {{ endDate | date : 'mediumDate' }}</label>
        </div>
      }
    </mat-dialog-content>
    @if(!!companiesWithoutPayeeCodeCount || !!companiesWithoutPayeeCodeSigningCount) {
    <h1 mat-dialog-title class="report-form-header">Action Required:</h1>
    }
    @if(!!companiesWithoutPayeeCodeCount) {
    <div class="mb-2">
      There are {{ companiesWithoutPayeeCodeCount }} companies with archived enrollments that will not be included
      in the report since they are missing payee code:
    </div>
    @for (company of companiesWithoutPayeeCode; track $index) {
    <div class="d-flex justify-content-center p-2" [ngClass]="{'even-company-row': $even}">
      {{ company.companyName }}
    </div>
    }
    <mat-dialog-actions class="mb-0 mt-2" align="end">
      <button mat-raised-button type="button" color="primary" mat-dialog-close
        (click)="navigateToProgramEnrollmentsArchive()">
        View All Companies ({{ companiesWithoutPayeeCodeCount }})
      </button>
    </mat-dialog-actions>
    }
    @if(!!companiesWithoutPayeeCodeSigningCount) {
    <div class="mb-2">
      There are {{ companiesWithoutPayeeCodeSigningCount }} companies with enrollments that will not be included
      in the report since they are missing payee code:
    </div>
    @for (company of companiesWithoutPayeeCodeSigning; track $index) {
    <div class="d-flex justify-content-center p-2" [ngClass]="{'even-company-row': $even}">
      {{ company.companyName }}
    </div>
    }
    <mat-dialog-actions class="mb-0 mt-2" align="end">
      <button mat-raised-button type="button" color="primary" mat-dialog-close (click)="navigateToProgramEnrollments()">
        View All Companies ({{ companiesWithoutPayeeCodeSigningCount }})
      </button>
      <button mat-raised-button type="button" color="primary" mat-dialog-close (click)="navigateToPayeeCode()">Add Payee
        Code</button>
    </mat-dialog-actions>
    }
    <mat-dialog-actions class="mb-0" align="end">
      <button mat-raised-button type="button" color="primary" mat-dialog-close>Cancel</button>
      <button mat-raised-button type="submit" color="primary" [disabled]="!reportForm.valid">
        <mat-icon class="icon-white">queue</mat-icon>&nbsp;&nbsp;&nbsp;{{ buttonLabel || 'Schedule Report' }}
      </button>
    </mat-dialog-actions>
  </form>
}

<app-in-progress [loading]="areCompaniesWithoutPayeeCodeLoading"></app-in-progress>